import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import mascot from "../assets/mascot.webp";

export default function Preloader({ onGone }) {
    const [pct, setPct] = useState(0);
    const [fade, setFade] = useState(false);

    useEffect(() => {
        const t0 = Date.now();
        const dur = 450;
        const iv = setInterval(() => {
            const p = Math.min(1, (Date.now() - t0) / dur);
            setPct(Math.round((1 - Math.pow(1 - p, 3)) * 100));
            if (p >= 1) {
                clearInterval(iv);
                setFade(true);
            }
        }, 40);
        // never trap the user: hard cap removes the splash no matter what
        const hardCap = setTimeout(onGone, 2200);
        return () => {
            clearInterval(iv);
            clearTimeout(hardCap);
        };
    }, []);

    useEffect(() => {
        if (!fade) return;
        const t = setTimeout(onGone, 600);
        return () => clearTimeout(t);
    }, [fade]);

    return (
        <motion.div
            data-testid="preloader"
            className="pointer-events-none fixed inset-0 z-[100] flex flex-col items-center justify-center bg-blast-bg"
            initial={{ opacity: 1 }}
            animate={{ opacity: fade ? 0 : 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <div className="relative">
                <div
                    className="absolute inset-[-14%] animate-spin-slow rounded-full border border-dashed border-white/15"
                    aria-hidden="true"
                />
                <img
                    src={mascot}
                    alt="BLASTARDIO"
                    className="floaty h-28 w-28 rounded-full ring-2 ring-blast-pink/40"
                />
            </div>
            <p className="mt-8 font-display text-2xl font-black tracking-wider">
                BLASTARDIO
            </p>
            <p className="mt-2 font-mono text-[10px] tracking-[0.35em] text-white/40">
                LOADING FUEL
            </p>
            <div className="mt-6 h-[3px] w-44 overflow-hidden rounded-full bg-white/10">
                <div
                    className="h-full rounded-full bg-gradient-to-r from-blast-pink via-blast-rose to-blast-violet transition-all duration-150"
                    style={{ width: `${pct}%` }}
                    data-testid="preloader-bar"
                />
            </div>
            <p className="mt-3 font-mono text-xs font-bold text-blast-pink" data-testid="preloader-pct">
                {pct}%
            </p>
        </motion.div>
    );
}
